import ApiUtil from './apiUtil';
import axios from 'axios';

const getHeaders = () => {
    return {};
};

export default class HttpProvider {
    static fetch({ url, method, headers, data, params, otherConfigs }) {
        return axios({
            url,
            method,
            headers,
            data,
            params,
            timeout: 15 * 1000,
            ...otherConfigs,
        })
            .then((res) => {
                return Promise.resolve(res.data);
            })
            .catch((err) => {
                const { message } = err;

                // 網路錯誤
                if (message.includes('timeout') || message.includes('Network Error')) {
                }

                if (axios.isCancel(err)) {
                    //被取消請求
                }

                return Promise.reject(err);
            });
    }

    static post(url, data) {
        return HttpProvider.fetch({
            url: ApiUtil.restUrlFull(url),
            method: 'POST',
            headers: getHeaders(),
            data,
        });
    }

    static get(url, params) {
        return HttpProvider.fetch({
            url: ApiUtil.restUrlFull(url),
            method: 'GET',
            headers: getHeaders(),
            params,
        });
    }

    static getHttpUrl(url, params) {
        return HttpProvider.fetch({
            url,
            method: 'GET',
            params,
        });
    }
}
